import { Button, ButtonProps } from "./catalyst/button";
import { SUPPORT_EMAIL } from "@/lib/constants";
import { TextLink } from "./catalyst/text";
import { Link } from "./catalyst/link";

type EmailProps = {
  subject?: string;
  body?: string;
  address?: string;
  cc?: string;
  bcc?: string;
};

export function SupportEmailTextLink({
  subject,
  body,
  cc,
  bcc,
  address = SUPPORT_EMAIL,
  children = SUPPORT_EMAIL,
  ...props
}: Omit<React.ComponentPropsWithoutRef<typeof TextLink>, "href"> & EmailProps) {
  return (
    <TextLink
      {...props}
      href={generateMailtoLink({ subject, body, address, cc, bcc })}
    >
      {children}
    </TextLink>
  );
}

export function SupportEmailLink({
  subject,
  body,
  cc,
  bcc,
  address = SUPPORT_EMAIL,
  children,
  ...props
}: Omit<React.ComponentPropsWithoutRef<typeof Link>, "href"> & EmailProps) {
  return (
    <Link
      {...props}
      href={generateMailtoLink({ subject, body, address, cc, bcc })}
    >
      {children}
    </Link>
  );
}

export type SupportEmailButtonProps = ButtonProps & EmailProps;

export function SupportEmailButton({
  subject,
  body,
  cc,
  bcc,
  address = SUPPORT_EMAIL,
  children,
  ...props
}: SupportEmailButtonProps) {
  return (
    <Button
      {...props}
      href={generateMailtoLink({ subject, body, address, cc, bcc })}
    >
      {children}
    </Button>
  );
}

function generateMailtoLink({
  address,
  subject,
  body,
  cc,
  bcc,
}: {
  address?: string;
  subject?: string;
  body?: string;
  cc?: string;
  bcc?: string;
}) {
  const properties = {
    ...(subject ? { subject } : {}),
    ...(body ? { body } : {}),
    ...(cc ? { cc } : {}),
    ...(bcc ? { bcc } : {}),
  };

  const queryString = Object.entries(properties)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  return `mailto:${address}?${queryString}`;
}
